import { clsx } from 'clsx';
import Select, { Props, StylesConfig } from 'react-select';

import {
    baseStyles,
    ClearIndicator,
    DropdownIndicator,
    Option,
} from '@/components/shared/Dropdown/constants.tsx';

import cn from './styles.module.sass';

export const Dropdown = ({
    options,
    styles,
    className,
    classNames,
    components,
    ...props
}: Props) => {
    const { menu, ...restClassNames } = classNames || {};

    return (
        <Select
            className={clsx(cn.container, className)}
            classNames={{
                menu: props => (menu ? menu(props) + ' ' + cn.menu : cn.menu),
                ...restClassNames,
            }}
            isSearchable={false}
            hideSelectedOptions={false}
            styles={{ ...baseStyles, ...styles } as StylesConfig}
            options={options}
            components={{
                Option,
                DropdownIndicator,
                ClearIndicator,
                ...components,
            }}
            {...props}
        />
    );
};
